import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

import i18nCommon from "@/locales/common";
import i18nDatetime from "@/locales/datetimeFormats";
import i18nNumbers from "@/locales/numberFormats";

const ENGLISH_LOCALE = "en";
const FALLBACK_LOCALE = ENGLISH_LOCALE;
const LANG_LIST = [ENGLISH_LOCALE];

function setLang() {
  const lang = navigator.languages[0].split("-")[0];

  return LANG_LIST.includes(lang) ? lang : FALLBACK_LOCALE;
}

export const i18n = new VueI18n({
  locale: setLang(),
  fallbackLocale: FALLBACK_LOCALE,
  silentFallbackWarn: false,
  dateTimeFormats: i18nDatetime,
  numberFormats: i18nNumbers,
  messages: i18nCommon,
});
